import { render, staticRenderFns } from "./bank.vue?vue&type=template&id=b8ddd7e4"
import script from "./bank.vue?vue&type=script&lang=js"
export * from "./bank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports